/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_Min_Frame_GapInputs */

const en_options_editor_min_frame_gap = /** @type {(inputs: Options_Editor_Min_Frame_GapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min. Frame Gap`)
};

const fr_options_editor_min_frame_gap = /** @type {(inputs: Options_Editor_Min_Frame_GapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Écart min. en images`)
};

const de_options_editor_min_frame_gap = /** @type {(inputs: Options_Editor_Min_Frame_GapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mindestrahmenabstand`)
};

const it_options_editor_min_frame_gap = /** @type {(inputs: Options_Editor_Min_Frame_GapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Distanza minima tra i telai`)
};

const ru_options_editor_min_frame_gap = /** @type {(inputs: Options_Editor_Min_Frame_GapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Минимальный зазор между кадрами`)
};

const es_options_editor_min_frame_gap = /** @type {(inputs: Options_Editor_Min_Frame_GapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espacio mínimo entre marcos`)
};

const zh_cn2_options_editor_min_frame_gap = /** @type {(inputs: Options_Editor_Min_Frame_GapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最小帧间隙`)
};

const ja_options_editor_min_frame_gap = /** @type {(inputs: Options_Editor_Min_Frame_GapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最小フレームギャップ`)
};

const hi_options_editor_min_frame_gap = /** @type {(inputs: Options_Editor_Min_Frame_GapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`न्यूनतम फ्रेम अंतर`)
};

const pt_pt2_options_editor_min_frame_gap = /** @type {(inputs: Options_Editor_Min_Frame_GapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espaço mínimo entre quadros`)
};

/**
* | output |
* | --- |
* | "Min. Frame Gap" |
*
* @param {Options_Editor_Min_Frame_GapInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_min_frame_gap = /** @type {((inputs?: Options_Editor_Min_Frame_GapInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_Min_Frame_GapInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_editor_min_frame_gap(inputs)
	if (locale === "de") return de_options_editor_min_frame_gap(inputs)
	if (locale === "it") return it_options_editor_min_frame_gap(inputs)
	if (locale === "ru") return ru_options_editor_min_frame_gap(inputs)
	if (locale === "es") return es_options_editor_min_frame_gap(inputs)
	if (locale === "zh-CN") return zh_cn2_options_editor_min_frame_gap(inputs)
	if (locale === "ja") return ja_options_editor_min_frame_gap(inputs)
	if (locale === "hi") return hi_options_editor_min_frame_gap(inputs)
	if (locale === "pt-PT") return pt_pt2_options_editor_min_frame_gap(inputs)
	return en_options_editor_min_frame_gap(inputs)
});